/**
 * Login flyout component
 * 
 * @module login-flyout
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'login-flyout';

 if (!customElements.get(customElements.component)) {
 
     class loginFlyout extends HTMLElement {

    /**
     * Login flyout web component
     * 
     * @constructor
     */
    constructor() {

        super();

		this.initCloseEvents();
		this.initOpenEvents();
    }

	/**
	 * start to listen the click button to close login flyout
     * 
     * @returns {undefined}
	 */
	initCloseEvents () {

		// Close login flyout when click on overlay
		document.querySelector('[data-login-overlay]').addEventListener('click', (event) => {
			event.preventDefault();
			this.close();
		});

		// Close login flyout  when click on close button
		this.querySelectorAll('[data-login-close]').forEach( (btn) => {
			btn.addEventListener('click', (event) => {
				event.preventDefault();
				this.close();
			});
		});

		// Close login flyout on press escape
		window.addEventListener('escape', (event) => {
			this.close();
		});
	}

	/**
	 * hide login flyout
     * 
     * @returns {undefined}
	 */
	 close()  {

        this.disableFocusTrap();

        document.body.classList.remove('overflow-hidden');

        this.classList.remove('active');

        document.querySelector('[data-login-overlay]').classList.remove('active');


        // We need to use set time out to avoid issues with menu animation
        setTimeout(() => {

            this.setAttribute('aria-hidden', 'true');

            this.classList.add('hidden');
        }, 500);
	}

	/**
	 * open login flyout when clicking on login icon
     * 
     * @returns {undefined}
	 */ 
	 initOpenEvents ()  {
		let openButton = document.querySelectorAll('[ ]');
        
		openButton.forEach((btn) => {

			btn.addEventListener('click', event => {
				event.preventDefault();
				// this.closeMenu();
				this.open();
			});
		});
	}

	/**
	 * show login flyout
     * 
     * @returns {undefined}
	 */
	 open() {

        this.classList.remove('hidden');    

        this.setAttribute('aria-hidden', 'false');

        document.querySelector('[data-login-overlay]').classList.add('active');
    
        setTimeout(() => {

            this.classList.add('active');

			document.body.classList.add('overflow-hidden');

            this.initFocusTrap();

            this.activeFocusTrap();
        
            this.querySelector('[data-login-close]').focus();

        }, 100);   
		
	}

	/**
	 * Init login flyout focus trap
     * 
     * @returns {undefined}
	 */
     initFocusTrap ()  {

        this.focusTrap = focusTrap.createFocusTrap(this, { clickOutsideDeactivates: true });
    }

	/**
	 * Ative login flyout focus trap
     * 
     * @returns {undefined}
	 */
	 activeFocusTrap ()  {

        if (this.focusTrap) {
            this.focusTrap.activate();
        }
    }

	/**
	 * Disable login focus trap
     * 
     * @returns {undefined}
	 */
	disableFocusTrap() {

		if (this.focusTrap) {
			this.focusTrap.deactivate();
		}
	}

	/**
	* Close menu
	* 
	* @return {undefined}
	*/
   closeMenu() {
		let menu = document.querySelector("component-menu");

	   this.disableMenuFocusTrap(menu);

	   menu.classList.remove('active');

	   document.body.classList.remove('overflow-hidden');
	   document.body.classList.remove('fixed');
	   document.body.classList.remove('w-full');

	   document.querySelector('[data-menu-overlay]').classList.add('hidden');

		// We need to use set time out to avoid issues with menu animation
		setTimeout(() => {

			menu.setAttribute('aria-hidden', 'true');

			menu.activeToggle.focus();
			

			menu.openStatus = false;

			menu.classList.add('hidden');
		}, 500);
   }

   	/**
	 * Disable menu focus trap
     * 
     * @returns {undefined}
	 */
	disableMenuFocusTrap(menu) {

		if (menu.focusTrap) {
			menu.focusTrap.deactivate();
		}
	}
}

customElements.define(customElements.component, loginFlyout);
}
